import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useAppVersion } from '../../hooks/useAppVersion';

const UpdateBanner = () => {
  const { updateAvailable, applyUpdate, currentVersion, newVersion } = useAppVersion();
  const [countdown, setCountdown] = useState(30); // 30 segundos para auto-atualização
  const [autoUpdateEnabled, setAutoUpdateEnabled] = useState(true);

  // Countdown para auto-atualização
  useEffect(() => {
    let interval;
    
    if (updateAvailable && autoUpdateEnabled && countdown > 0) {
      interval = setInterval(() => {
        setCountdown(prev => {
          if (prev <= 1) {
            // Auto-aplicar atualização quando countdown chegar a 0
            handleUpdate(true);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [updateAvailable, autoUpdateEnabled, countdown]);

  if (!updateAvailable) return null;

  const handleUpdate = (isAuto = false) => {
    const message = isAuto 
      ? `Auto-atualizando de v${currentVersion}...`
      : `Atualizando de v${currentVersion} para ${newVersion}...`;
    
    toast.success(message);
    setAutoUpdateEnabled(false); // Parar countdown
    applyUpdate();
  };

  const handleDismiss = () => {
    setAutoUpdateEnabled(false);
    toast('Atualização adiada. Você pode atualizar mais tarde.', {
      icon: '⏰',
      duration: 3000
    });
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-gradient-to-r from-blue-600 to-blue-700 text-white p-3 sm:p-4 flex flex-col sm:flex-row justify-between items-start sm:items-center z-50 shadow-lg">
      <div className="flex items-start sm:items-center space-x-3 mb-3 sm:mb-0 flex-1">
        <div className="flex-shrink-0 mt-1 sm:mt-0">
          <svg className="h-5 w-5 sm:h-6 sm:w-6 text-blue-200" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
          </svg>
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-semibold text-sm sm:text-base">Nova versão disponível!</div>
          <div className="text-xs sm:text-sm text-blue-100 mt-1">
            Atualize de v{currentVersion} para obter as últimas melhorias
          </div>
          {autoUpdateEnabled && countdown > 0 && (
            <div className="text-xs text-blue-200 mt-1">
              Auto-atualização em {countdown}s
            </div>
          )}
        </div>
      </div>
      
      <div className="flex space-x-2 w-full sm:w-auto">
        {autoUpdateEnabled && (
          <button
            onClick={handleDismiss}
            className="flex-1 sm:flex-none px-3 py-2 text-xs sm:text-sm bg-blue-800 text-blue-100 rounded-lg hover:bg-blue-900 transition-all duration-200"
          >
            Mais tarde
          </button>
        )}
        <button
          onClick={() => handleUpdate(false)}
          className="flex-1 sm:flex-none bg-white text-blue-600 px-4 py-2 rounded-lg font-semibold hover:bg-blue-50 transition-all duration-200 shadow-md hover:shadow-lg text-xs sm:text-sm"
        >
          Atualizar agora
        </button>
      </div>
    </div>
  );
};

export default UpdateBanner;
